import React from 'react';
import { Shield, Lock, Users, FileCheck } from 'lucide-react';
export function SecurityPage() {
  return <div className="pt-32 pb-20" data-id="element-7131">
      <section className="max-w-4xl mx-auto px-6 text-center mb-24" data-id="element-7132">
        <div className="w-16 h-16 rounded-2xl bg-surface border border-border flex items-center justify-center mx-auto mb-8" data-id="element-7133">
          <Shield className="w-8 h-8 text-textMain" data-id="element-7134" />
        </div>
        <h1 className="text-5xl font-bold tracking-tight mb-6" data-id="element-7135">
          Built for high-stakes booking workflows.
        </h1>
        <p className="text-xl text-textMuted max-w-2xl mx-auto" data-id="element-7136">
          Enterprise-grade security, granular permissions, and comprehensive
          audit logging to protect your roster, contracts, and financial data.
        </p>
      </section>

      <section className="max-w-5xl mx-auto px-6" data-id="element-7137">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-7138">
          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-7139">
            <Users className="w-6 h-6 text-primary mb-4" data-id="element-7140" />
            <h3 className="text-xl font-semibold mb-2" data-id="element-7141">
              Role-Based Access Control
            </h3>
            <p className="text-textMuted" data-id="element-7142">
              Granular permissions ensure agents, coordinators, and artists only
              see what they need to see. Restrict financial data and contract
              signing authority.
            </p>
          </div>
          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-7143">
            <FileCheck className="w-6 h-6 text-primary mb-4" data-id="element-7144" />
            <h3 className="text-xl font-semibold mb-2" data-id="element-7145">Audit Logging</h3>
            <p className="text-textMuted" data-id="element-7146">
              Every deal stage change, contract generation, and approval is
              logged with a timestamp and user ID for complete operational
              transparency.
            </p>
          </div>
          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-7147">
            <Lock className="w-6 h-6 text-primary mb-4" data-id="element-7148" />
            <h3 className="text-xl font-semibold mb-2" data-id="element-7149">Document Security</h3>
            <p className="text-textMuted" data-id="element-7150">
              Contracts and riders are securely stored and transmitted.
              E-signatures comply with major international electronic signature
              laws.
            </p>
          </div>
          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-7151">
            <Shield className="w-6 h-6 text-primary mb-4" data-id="element-7152" />
            <h3 className="text-xl font-semibold mb-2" data-id="element-7153">Authentication</h3>
            <p className="text-textMuted" data-id="element-7154">
              Support for Two-Factor Authentication (2FA) and Single Sign-On
              (SSO) for agency and enterprise accounts.
            </p>
          </div>
        </div>
      </section>
    </div>;
}